import { render } from "./ticker.vue?vue&type=template&id=5742490d&scoped=true"
import script from "./ticker.vue?vue&type=script&lang=js"
export * from "./ticker.vue?vue&type=script&lang=js"

import "./ticker.vue?vue&type=style&index=0&id=5742490d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5742490d"]])

export default __exports__